// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { xBaseTheme } from "@werner/XDL/types";
import { color, styledScrollbar } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            ...OverflowMenuPresentationPropsDefault?.buttonProps,
            css: css`
                border: 0;
                min-height: 40px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-left: 5px;
                display: flex;
                justify-content: center;
                &:hover:not(:disabled),
                &:focus:not(:disabled) {
                    background: ${color("common.ui2")};
                    ${IconWrapper} {
                        color: ${color("text.main")};
                    }
                }
            `,
        },
        iconProps: { src: "MoreVertical", color: "common.ui3" },
        cssOverrides: {
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(6)}
            `,
            menuItem: css`
                &:hover {
                    background: ${color("common.ui2")};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
